import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { HTTPError, post } from "common/helpers/HTTP";
import type { ProfileSearchParams } from "common/types";

import { useCampaignContext } from "../context/CampaignContext";

async function pasteUrlTargetingRequest(
  workspaceId: string,
  campaignId: string,
  url: string,
): Promise<Partial<ProfileSearchParams>> {
  return (
    await post(`workspaces/${workspaceId}/campaigns/${campaignId}/search/url`, {
      url,
    })
  ).result;
}

export default function usePasteUrlTargeting() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { id: campaignId } = useCampaignContext();

  const {
    mutateAsync: getSearchParamsFromUrl,
    isPending: isGettingSearchParamsFromUrl,
  } = useMutation({
    mutationFn: ({ url }: { url: string }) =>
      pasteUrlTargetingRequest(workspaceId, campaignId, url),
    onSuccess: () => toast.success("Targeting updated"),
    onError: (error) => {
      if (
        error instanceof HTTPError &&
        error.serverMessage === "InvalidUrlFormat"
      ) {
        toast.error("Invalid URL format. Please check the URL and try again.");
      } else {
        toast.error("Error getting targeting from URL");
      }
    },
  });

  return { getSearchParamsFromUrl, isGettingSearchParamsFromUrl };
}
